import { SectionProps } from '../types';

export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  id,
  background = 'black',
}) => {
  const bgStyles = {
    black: 'bg-deepBlack',
    gray: 'bg-panelGray',
  };

  return (
    <section
      id={id}
      className={`py-20 px-6 md:px-12 lg:px-20 ${bgStyles[background]} ${className}`}
    >
      <div className="max-w-7xl mx-auto">
        {children}
      </div>
    </section>
  );
};
